exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../node_modules/postcss-loader/index.js!./_base.css"), undefined);

// module
exports.push([module.id, "._3Q9rTqv61jz1TMbQgSC21Y {\n    margin-bottom: 3.2px;\n    margin-bottom: 0.2rem;\n}\n\n.pfwgw1KVkaL-Jspb7XsLn {\n}\n\n._3qTEJI-SGaaBwcproq96Z9 {\n}\n\n._1C3jrn92-2_teD3Q_-WwDn {\n}\n", ""]);

// exports
exports.locals = {
	"container": "_3Q9rTqv61jz1TMbQgSC21Y",
	"name": "pfwgw1KVkaL-Jspb7XsLn " + require("-!./../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../node_modules/postcss-loader/index.js!./_base.css").locals["fieldName"] + "",
	"argumentName": "_3qTEJI-SGaaBwcproq96Z9 " + require("-!./../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../node_modules/postcss-loader/index.js!./_base.css").locals["argumentName"] + "",
	"defaultValue": "_1C3jrn92-2_teD3Q_-WwDn " + require("-!./../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../node_modules/postcss-loader/index.js!./_base.css").locals["defaultValue"] + ""
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/FieldSyntaxView.css
 ** module id = 19
 ** module chunks = 0
 **/